<ngx-charts-tree-map
  [view]="view"
  [results]="data"
  [gradient]="enableGradient"
  [animations]="enableAnimations"
  [tooltipDisabled]="tooltipDisabled"
  (select)="onSelect($event)"
>
</ngx-charts-tree-map>
